// extracted by mini-css-extract-plugin
export var aircallIframe = "_er-3";
export var fabContainer = "_er-5";
export var fabRinging = "_er-6";
export var loadingOverlay = "_er-4";
export var pulse = "_er-7";
export var widgetContent = "_er-2";
export var widgetPanel = "_er-0";
export var widgetPanelExpanded = "_er-1";